import { Avatar, Text, ActionIcon } from '@mantine/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FiLogOut } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { logout } from '../actions/authActions';

const User = () => {

    const dispatch = useDispatch();
    const { userInfo } = useSelector((state) => state.userAccess);

    const handlerLogout = () => {
        dispatch(logout())
    }

    return (
        <Link style={{ width: '100%' }} to='/user'>
            <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                    <Avatar color="blue" radius="md">{userInfo.user.username.charAt(0)}</Avatar>
                    <Text sx={{ marginLeft: '10px' }}>{userInfo.user.username}</Text>
                </span>
                <ActionIcon onClick={() => handlerLogout()} color="red" radius='md' variant='light'><FiLogOut /></ActionIcon>
            </span>
        </Link>
    )
}

export default User
